import type { AuthMessagePayload } from '../types/auth'

export function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

export function asString(value: unknown): string | null {
  return typeof value === 'string' ? value : null
}

export function asStringOrNull(value: unknown): string | null {
  return value === null || typeof value === 'string' ? value : null
}

export function asBoolean(value: unknown): boolean | null {
  return typeof value === 'boolean' ? value : null
}

export function asIntegerOrNull(value: unknown): number | null {
  return Number.isInteger(value) ? Number(value) : null
}

export function asFiniteNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

export function assertValid<T>(value: T | null, message: string): T {
  if (value === null) {
    throw new Error(message)
  }

  return value
}

export function validateAuthMessagePayload(value: unknown): AuthMessagePayload | null {
  if (value === null) {
    return null
  }

  if (!isRecord(value)) {
    throw new Error('Некорректный формат ответа API: сообщение операции имеет неверную структуру.')
  }

  const payload: AuthMessagePayload = {}

  if (value.message !== undefined) {
    if (typeof value.message !== 'string') {
      throw new Error('Некорректный формат ответа API: message должен быть строкой.')
    }
    payload.message = value.message
  }

  if (value.requireRelogin !== undefined) {
    if (typeof value.requireRelogin !== 'boolean') {
      throw new Error('Некорректный формат ответа API: requireRelogin должен быть boolean.')
    }
    payload.requireRelogin = value.requireRelogin
  }

  if (value.requirePasswordChange !== undefined) {
    if (typeof value.requirePasswordChange !== 'boolean') {
      throw new Error('Некорректный формат ответа API: requirePasswordChange должен быть boolean.')
    }
    payload.requirePasswordChange = value.requirePasswordChange
  }

  return payload
}
